import ContentError from 'components/ContentError'
import ContentLoading from 'components/ContentLoading'
import {
  DropdownItem,
  DropdownItemDescription,
  DropdownItemTitle,
  DropdownScroll,
} from 'components/Dropdown'
import Icon from 'components/Icon'
import { useBrandingSettings } from 'hooks/branding'
import { useActivation } from 'hooks/mobx-hooks'
import { observer } from 'mobx-react'
import React from 'react'
import { FilterSearchBar, FilterViewHeader } from '..'
import { SelectFilter } from './SelectFilter'

interface SelectFilterViewProps<TFilters extends Record<string, unknown>> {
  filter: SelectFilter<keyof TFilters, any>
}

export const SelectFilterView = observer(function SelectFilterView<
  TFilters extends Record<string, unknown>
>({ filter }: SelectFilterViewProps<TFilters>) {
  const branding = useBrandingSettings()
  const searchEnabled = filter.options.length >= 5
  useActivation(filter)

  return (
    <>
      <FilterViewHeader
        title={filter.title}
        dataTest={'job-select-filter-clear-button'}
        onClear={() => {
          filter.clearValue()
          filter.stopEditing()
        }}
      />
      {searchEnabled && (
        <FilterSearchBar onChange={(text) => filter.changeSearchText(text)} />
      )}
      <DropdownScroll>
        {filter.loadOptions.match({
          pending: () => <ContentLoading compact />,
          rejected: (err: any) => <ContentError error={err} />,
          resolved: () =>
            filter.searchFilterOptions.map((c, index) => (
              <DropdownItem
                key={`${c.title}-${index}`}
                data-test={'job-select-filter-option-' + c.title}
                onClick={() => filter.toggle(c.value)}
                icon={
                  <Icon
                    color={branding.themePrimary}
                    name={
                      filter.isSelected(c.value) ? 'checkbox' : 'checkbox-blank'
                    }
                  />
                }
              >
                <DropdownItemTitle>{c.title}</DropdownItemTitle>
                <DropdownItemDescription>
                  {c.description}
                </DropdownItemDescription>
              </DropdownItem>
            )),
        })}
      </DropdownScroll>
    </>
  )
})
